<div class="events-page">
  <header class="events-page__header">
    <h1 class="events-page__title">{{ heading() }}</h1>
    <p class="events-page__subtitle">{{ copy.subtitle }}</p>

    @if (isGamePage()) {
      <a class="events-page__back" [routerLink]="['/juegos', routeGameSlug()]">
        ← Volver a la sección del juego
      </a>
    }
  </header>

  <div class="events-page__toolbar">
    <!-- Conmutador lista ↔ calendario. El modo vive en la URL: la vista
         sobrevive a un refresco y se puede enlazar. -->
    <div class="events-page__switcher" role="group" [attr.aria-label]="copy.viewSwitcherLabel">
      <button
        type="button"
        class="events-page__switch"
        [class.events-page__switch--active]="mode() === 'lista'"
        [attr.aria-pressed]="mode() === 'lista'"
        (click)="setMode('lista')"
      >
        <app-icon [icon]="listIcon" [size]="16" />
        {{ copy.listView }}
      </button>
      <button
        type="button"
        class="events-page__switch"
        [class.events-page__switch--active]="mode() === 'calendario'"
        [attr.aria-pressed]="mode() === 'calendario'"
        (click)="setMode('calendario')"
      >
        <app-icon [icon]="calendarIcon" [size]="16" />
        {{ copy.calendarView }}
      </button>
    </div>

    <!-- El filtro por juego solo tiene sentido en la agenda global: en la de un
         juego, el juego lo fija la ruta. -->
    @if (!isGamePage() && gameOptions().length > 0) {
      <label class="events-page__filter">
        <span class="events-page__filter-label">{{ copy.gameFilterLabel }}</span>
        <select
          class="events-page__select"
          [value]="filterGameSlug() ?? ''"
          (change)="onGameFilterChange($event)"
        >
          <option value="">{{ copy.allGames }}</option>
          @for (game of gameOptions(); track game.slug) {
            <option [value]="game.slug">{{ game.name }}</option>
          }
        </select>
      </label>
    }
  </div>

  <!-- En la lista de un juego no hay navegador de mes: enseña todo lo que
       viene, que es justo lo que la landing recorta. -->
  @if (showsMonthNav() && mode() === 'lista') {
    <div class="events-page__month-nav">
      <button
        type="button"
        class="events-page__month-button"
        (click)="shiftMonthBy(-1)"
        aria-label="Mes anterior"
      >
        <app-icon [icon]="chevronLeftIcon" [size]="20" />
      </button>
      <span class="events-page__month-label" aria-live="polite">{{ monthHeading() }}</span>
      <button
        type="button"
        class="events-page__month-button"
        (click)="shiftMonthBy(1)"
        aria-label="Mes siguiente"
      >
        <app-icon [icon]="chevronRightIcon" [size]="20" />
      </button>
    </div>
  }

  @if (status() === 'loading') {
    <!-- Skeleton: nunca una pantalla en blanco mientras llega el API. -->
    <div class="events-page__skeleton" aria-busy="true" aria-label="Cargando eventos">
      @if (mode() === 'calendario') {
        <div class="events-skeleton__calendar" aria-hidden="true">
          @for (cell of skeletonCells; track cell) {
            <span class="events-skeleton__cell"></span>
          }
        </div>
      } @else {
        @for (row of skeletonRows; track row) {
          <div class="events-skeleton__row" aria-hidden="true">
            <span class="events-skeleton__date"></span>
            <div class="events-skeleton__body">
              <span class="events-skeleton__line events-skeleton__line--name"></span>
              <span class="events-skeleton__line events-skeleton__line--meta"></span>
            </div>
          </div>
        }
      }
    </div>
  } @else if (status() === 'error') {
    <p class="events-page__state events-page__state--error" role="alert">
      {{ copy.loadError }}
    </p>
  } @else if (mode() === 'calendario') {
    <app-events-calendar
      [month]="month()"
      [events]="events()"
      (monthChange)="setMonth($event)"
    />
  } @else if (isEmpty()) {
    <p class="events-page__state">{{ emptyMessage() }}</p>
  } @else {
    <div class="events-page__list">
      @for (event of events(); track event.id) {
        <app-event-card [event]="event" [showImage]="true" />
      }
    </div>
  }
</div>
